__turbopack_context__.v({
  "Buttons": "Teaser-module-scss-module__lun5eq__Buttons",
  "Content": "Teaser-module-scss-module__lun5eq__Content",
  "Description": "Teaser-module-scss-module__lun5eq__Description",
  "HasBorder": "Teaser-module-scss-module__lun5eq__HasBorder",
  "Icon": "Teaser-module-scss-module__lun5eq__Icon",
  "Tags": "Teaser-module-scss-module__lun5eq__Tags",
  "Teaser": "Teaser-module-scss-module__lun5eq__Teaser",
  "Title": "Teaser-module-scss-module__lun5eq__Title",
});
